<template lang="pug">
.senddocument-remind-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="send" @cancel="cancel")
    div(slot="modal-title")
      span {{ modalTitle }}

    .testmail-modal-body
      div.mb-2
        span 未同意もしくは未確認の方にメッセージを再送し、同意もしくは確認の返信を促すことが出来ます。
        br
        span メッセージのタイトルと本文は編集できますが、添付文書は変更することが出来ません。
      .register-body
        .register-row.form-label
          .register-group
            .register-key
              span.key-name 宛先
            .register-value.d-flex.flex-column.align-items-start
              div(v-for="target in targets" :key="target.key")
                b-form-checkbox(
                  :id="'id-' + target.key"
                  v-model="target.isTarget"
                  :name="'name-' + target.key"
                  :value="true"
                  :unchecked-value="false") {{ target.displayName }}
        FormInput(v-model="_remindTitle" name="remind-title" key-name="タイトル" type="text" placeholder="タイトル"
          :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ maxWidth: '720px', width: '720px' }" required)
        FormTextarea(v-model="_remindText" name="remind-text" key-name="本文" placeholder="本文" :maxlength="1000" 
          :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }" required)

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()" :class="{ 'disable': _disableOk }" :disabled="_disableOk") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormLabel from "@/pc/components/forms/FormLabel.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import { OptionTargetFamilyTableItem } from "@/pc/containers/sendDocuments/OptionTargetFamilyTable.vue";
import { OptionTargetOtherUserTableItem } from "@/pc/containers/sendDocuments/OptionTargetOtherUserTable.vue";

@Component({
  components: {
    ValidationAlert,
    FormLabel,
    FormInput,
    FormTextarea
  }
})
export default class RemindModal extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop({ required: true })
  value!: boolean;

  @Prop({ required: true })
  modalTitle!: string;

  @Prop()
  targets!: Array<OptionTargetFamilyTableItem | OptionTargetOtherUserTableItem>;

  @Prop({ required: true })
  remindTitle!: string;

  @Prop({ required: true })
  remindText!: string;

  @Prop()
  showValidationAlert!: boolean;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _remindTitle(): string {
    return this.remindTitle;
  }

  set _remindTitle(newValue: string) {
    this.$emit("update:remindTitle", newValue);
    return;
  }

  get _remindText(): string {
    return this.remindText;
  }

  set _remindText(newValue: string) {
    this.$emit("update:remindText", newValue);
    return;
  }

  get _disableOk(): boolean {
    for (const target of this.targets) {
      if (target.isTarget == true) {
        return false;
      }
    }
    return true;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.$emit("update:showValidationAlert", newValue);
    return;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public send(modalEvent: any): void {
    this.$emit("update:showValidationAlert", false);
    modalEvent.preventDefault();
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("update:showValidationAlert", false);
    return;
  }
}
</script>
